var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.23077C4.26146 1.23077 1.23077 4.26146 1.23077 8C1.23077 11.7385 4.26146 14.7692 8 14.7692C11.7385 14.7692 14.7692 11.7385 14.7692 8C14.7692 4.26146 11.7385 1.23077 8 1.23077ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM7.38462 4.71755C7.38462 4.37768 7.66013 4.10216 8 4.10216H8.00821C8.34807 4.10216 8.62359 4.37768 8.62359 4.71755C8.62359 5.05742 8.34807 5.33293 8.00821 5.33293H8C7.66013 5.33293 7.38462 5.05742 7.38462 4.71755ZM7.17969 7.38462C6.83982 7.38462 6.5643 7.66013 6.5643 8C6.5643 8.33987 6.83982 8.61539 7.17969 8.61539H7.38482V11.2821C7.38482 11.6219 7.66033 11.8974 8.0002 11.8974H8.82071C9.16058 11.8974 9.4361 11.6219 9.4361 11.2821C9.4361 10.9422 9.16058 10.6667 8.82071 10.6667H8.61559V8C8.61559 7.66013 8.34007 7.38462 8.0002 7.38462H7.17969Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.969f40cc695a15d5c7a78d8203560b59.svg";
export { ForwardRef as ReactComponent };